
































































































































import {
  AchievementsCount,
  BadgesCount,
  OpportunitiesCount,
  OneOfLatestAccomplishments,
  LatestAccomplishmentMetadata,
  LatestAccomplishmentType,
  } from '@/models/geek-profile';
import { latestAccomplishmentMixin } from '@/shared';
import { typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(latestAccomplishmentMixin).extend({
  name: 'ProfileTiles',
  props: {
    isActive: Boolean,
    isMyProfile: Boolean,
    achievementsCounter: Object as () => AchievementsCount,
    badgesCounter: Object as () => BadgesCount,
    opportunitiesCounter: Object as () => OpportunitiesCount,
    latestGained: Object as () => OneOfLatestAccomplishments,
    currentSeasonId: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      latestAccomplishment: {
        imageUrl: '',
        text: '',
      } as LatestAccomplishmentMetadata,
      latestAccomplishmentType: LatestAccomplishmentType,
    };
  },
  computed: {
    hasGeekSomeBadge(): boolean {
      return Object.keys(this.badgesCounter)
        .some((key: string) => this.badgesCounter[key] > 0);
    },
    hasGeekSomeOpportunity(): boolean {
      return this.opportunitiesCounter.opportunitiesCount > 0;
    },
    tileClass(): string {
      return this.achievementsCounter
             && this.badgesCounter
             && this.opportunitiesCounter
             ? 'col-12 col-xl-6 mt-xl-2' : 'align-self-center';
    },
  },
  methods: {
    goToAchievements() {
      if (this.isMyProfile) {
        return this.achievementsCounter.achievementsCount > 0
        ? this.$router.push({name: 'geek-achievements', query: {seasonId: this.currentSeasonId}})
        : this.$router.push({path: '/rules#rules-achievements'});
      }

      this.$router.push({name: 'geek-achievements'});
    },
    goToBadges() {
      if (this.isMyProfile) {
        return this.hasGeekSomeBadge
          ? this.$router.push({name: 'geek-badges', query: { seasonId: this.currentSeasonId }})
          : this.$router.push({path: '/rules#rules-badges'});
      }

      this.$router.push({name: 'geek-badges'});
    },
    goToOpportunities() {
      if (this.isMyProfile) {
        return this.hasGeekSomeOpportunity
          ? this.$router.push({name: 'geek-history'})
          : this.$router.push({name: 'opportunity'});
      }

      this.$router.push(
        {
          name: 'geek-history',
          query: { geekId: this.$route.query.geekId },
        },
      );
    },
    goToActivities() {
      this.$router.push({name: 'geek-activities', query: { seasonId: this.currentSeasonId }});
    },
  },
  watch: {
    latestGained() {
      this.refreshLatestAccomplishment();
    },
  },
});
